import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    CreateWarehouseCardMutation,
    CreateWarehouseCardMutationVariables,
    useCreateWarehouseCardMutation,
} from '../../../../generated/graphql';
import { WarehouseCardFormValues } from '../../../warehouse/components/WarehouseCards';
import WarehouseCardForm from '../../../warehouse/components/WarehouseCards/WarehouseCardsForm';
import { usePriceService } from '../../../../utils/hooks/priceService';
import { getPriceUpdateArgs } from '../../../warehouse/components/WarehouseCards/utils';

interface ProductCreateWarehouseCardProps {
    warehouseId: string;
    onMutationFinished: (stockCard: CreateWarehouseCardMutation) => void;
    onClose?: () => void;
    onlyPieces?: boolean;
}

const ProductCreateWarehouseCard = ({ warehouseId, onMutationFinished, onClose, onlyPieces }: ProductCreateWarehouseCardProps) => {
    const [runMutation] = useCreateWarehouseCardMutation({ onCompleted: onMutationFinished });
    const { priceService } = usePriceService();

    const onSubmit = async ({
        name,
        warehouseIds,
        categoryId,
        convertedQuanitity,
        convertedUnit,
        storageUnitId: storagUnitId,
        taxId,
        sku,
        priceWithoutVat,
    }: WarehouseCardFormValues) => {
        const priceUpdateArgs = getPriceUpdateArgs({ priceWithoutVat, warehouseIds, priceService });

        const variables: CreateWarehouseCardMutationVariables = {
            data: {
                name,
                sku,
                taxId,
                warehouseIds,
                storageUnit: storagUnitId,
                convertedAmount: convertedQuanitity ? parseFloat(convertedQuanitity.toString()) : null,
                conversionUnit: convertedUnit,
                stockCardCategoryId: categoryId,
            },
            priceUpdateArgs,
        };

        await runMutation({ variables });
    };

    const { t } = useTranslation();
    const buttonText = t('Create');
    const dialogName = t('New warehouse card');


    return (
        <WarehouseCardForm
            onlyPieces={onlyPieces}
            onClose={onClose}
            buttonText={buttonText}
            dialogName={dialogName}
            onSubmit={onSubmit}
            currentWarehouseId={warehouseId}
        />
    );
};

export default ProductCreateWarehouseCard;
